import React from 'react';
import '../../../styles/Auction.css';

const AuctionFilters = ({ value, onChange }) => {
    return (
        <div className="auction-filters">
            {/* Apply the floating-text class to the label */}
            <label htmlFor="status-filter" className="floating-text">
                Filter by Status:
            </label>
            <select
                id="status-filter"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="scheduled">Scheduled</option>
                <option value="active">Live</option>
                <option value="completed">Completed</option>
            </select>
        </div>
    );
};

export default AuctionFilters;